import { Injectable } from '@angular/core';

// Services
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  /**
   * Constructor
   */

  constructor(
    private toastrService: ToastrService
  ) { }

  /**
   * Methods
   */

  error(message: string, title?: string, timeout: boolean = false): ActiveToast<any> {
    return this.toastrService.error(title, message, {
      positionClass: 'toast-bottom-right',
      disableTimeOut: !timeout,
      closeButton: true,
    });
  }

  warning(message: string, title?: string, timeout: boolean = true): ActiveToast<any> {
    return this.toastrService.warning(title, message, {
      positionClass: 'toast-bottom-right',
      disableTimeOut: !timeout,
      closeButton: true,
    });
  }

  info(message: string, title?: string, timeout: boolean = true): ActiveToast<any> {
    return this.toastrService.info(title, message, {
      positionClass: 'toast-bottom-right',
      disableTimeOut: !timeout,
      closeButton: true,
    });
  }

  success(message: string, title?: string, timeout: boolean = true): ActiveToast<any> {
    return this.toastrService.success(title, message, {
      positionClass: 'toast-bottom-right',
      disableTimeOut: !timeout,
      closeButton: true,
    });
  }

}
